<template>
  <div class="viewer-app-tip" @mouseenter="$stat('pc_yunpan_web', 'yunpan_web_photo_browser_click', {clickid: '2d_code-hover'})" @click="handleOpenHeziOfficialWebsite">
    <span class="xlpfont xlp-btn-app-tip" />
    <span>下载迅雷盒子APP</span>
    <ViewerQrAppTip from="file_consumption_hover" />
  </div>
</template>

<script>
import ViewerQrAppTip from './ViewerQrAppTip'
export default {
  components: {
    ViewerQrAppTip,
  },
  methods: {
    handleOpenHeziOfficialWebsite () {
      window.open('https://hezi.xunlei.com/dl')
    },
  }
}
</script>

<style lang="scss">
.viewer-app-tip {
  margin-left: auto;
  cursor: pointer;
  position: relative;
  .xlp-btn-app-tip {
    font-size: 14PX !important;
    margin-right: 6PX;
  }
  &:hover {
    color: var(--color-primary);
    .xlp-btn-app-tip {
      color: var(--color-primary);
    }
    .qrcode-app-tip {
      display: block;
    }
  }
  .qrcode-app-tip {
    top: 26PX;
    left: -6PX;
  }
}
</style>
